module.exports = __webpack_public_path__ + "static/media/hpm-image-2.214f4562.jpeg";